import { render } from "./CampaignItem.vue?vue&type=template&id=5680622c"
import script from "./CampaignItem.vue?vue&type=script&lang=js"
export * from "./CampaignItem.vue?vue&type=script&lang=js"

import "./CampaignItem.vue?vue&type=style&index=0&id=5680622c&lang=css"
script.render = render

export default script